import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";
import { Input } from "@/components/ui/Input";
import { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from 'dayjs';
import { Checkbox, FormControlLabel } from '@mui/material';

interface CreateLiquidityScenarioDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateLiquidityScenario: (name: string, dateFrom: Date, dateTo: Date, includeCustomerTransactions: boolean, includeSupplierTransactions: boolean) => void;
}

export const CreateLiquidityScenarioDialog = ({
  open,
  onOpenChange,
  onCreateLiquidityScenario,
}: CreateLiquidityScenarioDialogProps) => {
  const [name, setName] = useState("");
  const today = dayjs();
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(today);
  const inTwoWeeks = today.add(14, 'day')
  const [dateTo, setDateTo] = useState<Dayjs | null>(inTwoWeeks);
  const [includeCustomerTransactions, setIncludeCustomerTransactions] = useState<boolean>(true);
  const [includeSupplierTransactions, setIncludeSupplierTransactions] = useState<boolean>(true);

  const cleanState = () => {
    // Reset dialog state
    setName("");
    setDateFrom(today)
    setDateTo(inTwoWeeks);
    onOpenChange(false);
    setIncludeCustomerTransactions(true);
    setIncludeSupplierTransactions(true);
  }

  const handleCreate = () => {
    onCreateLiquidityScenario(name.trim(), dateFrom.toDate(), dateTo.toDate(), includeCustomerTransactions, includeSupplierTransactions);
    cleanState();
  };

  const handleClose = () => {
    onOpenChange(false);
    cleanState();
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      title="Skapa nytt likviditetsscenario"
      footer={
        <div className="flex justify-end gap-4 pb-2 pr-2">
          <Button variant="outlined" onClick={() => handleClose()}>
            Avbryt
          </Button>
          <Button onClick={handleCreate} disabled={!name.trim()}>
            Skapa
          </Button>
        </div>
      }
    >
      <div>
        <div className="py-2">
          <Input
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="py-2">
          <h3 className="text-md font-medium">Scenariot innefattar:</h3>
          <div className="p-2">
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeCustomerTransactions}
                  onChange={(e) => setIncludeCustomerTransactions(e.target.checked)}
                />
              }
              label="Kundfakturor"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeSupplierTransactions}
                  onChange={(e) => setIncludeSupplierTransactions(e.target.checked)}
                />
              }
              label="Leverantörsfakturor"
            />
          </div>
        </div>

        <div>
          <h3 className="text-md font-medium mb-4">Period</h3>
          <div className="grid grid-cols-2 gap-4">
            <DatePicker
              label="Från"
              value={dateFrom}
              onChange={(newValue) => setDateFrom(newValue)}
            />
            <DatePicker
              label="Till"
              value={dateTo}
              onChange={(newValue) => setDateTo(newValue)}
            />
          </div>
        </div>
      </div>
    </Dialog >
  );
};